import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { getNewPaginationUriRef } from '../../utils/uriUtils';

import { SharedPaginationArrowItem } from './SharedPaginationArrowItem';
import { SharedPaginationPageItem } from './SharedPaginationPageItem';

function SharedPaginationItem({ type, pageNumber, isSelected, currentPage, uriRef, onLinkClick }) {
    switch (type) {
        case 'back': {
            const href = getNewPaginationUriRef(uriRef, currentPage - 1);
            return (
                <SharedPaginationArrowItem
                    isLeft
                    href={href}
                    onClick={e => onLinkClick({ e, href, pageNumber: currentPage - 1 })}
                    dataTn={`page-${type}`}
                >
                    <FormattedMessage id="SharedPagination.previous" defaultMessage="Previous" />
                </SharedPaginationArrowItem>
            );
        }
        case 'page': {
            const dataTn = `page-${pageNumber}${isSelected ? '-selected' : ''}`;
            const href = getNewPaginationUriRef(uriRef, pageNumber);
            return (
                <SharedPaginationPageItem
                    href={href}
                    isSelected={isSelected}
                    dataTn={dataTn}
                    onClick={e => onLinkClick({ e, href, pageNumber })}
                >
                    {pageNumber}
                </SharedPaginationPageItem>
            );
        }
        case 'ellipsis': {
            return <span>...</span>;
        }
        case 'forward': {
            const href = getNewPaginationUriRef(uriRef, currentPage + 1);
            return (
                <SharedPaginationArrowItem
                    href={href}
                    onClick={e => onLinkClick({ e, href, pageNumber: currentPage + 1 })}
                    dataTn={`page-${type}`}
                >
                    <FormattedMessage id="SharedPagination.next" defaultMessage="Next" />
                </SharedPaginationArrowItem>
            );
        }
        default: {
            return null;
        }
    }
}

SharedPaginationItem.propTypes = {
    type: PropTypes.string.isRequired,
    pageNumber: PropTypes.number,
    isSelected: PropTypes.bool,
    currentPage: PropTypes.number.isRequired,
    uriRef: PropTypes.string.isRequired,
    onLinkClick: PropTypes.func.isRequired,
};

export { SharedPaginationItem };
